import LandingContainer from "./components/LandingContainer";
import ThankYouContainer from "./components/ThankYouContainer";
import CheckoutContainer from "./components/checkout/CheckoutContainer";
import MySubscription from "./components/MySubscription";
import FreeTrial from "./components/FreeTrial";
import Error from "./components/Error";
import FreeTrialCheckout from "./components/FreeTrial/Checkout";
import messages from "./lang/default-messages";

const defaultLoadData = (dispatch) => {
  // Whatever is in here will get called for every route.
};

export default [
  {
    path: "/store",
    exact: true,
    secure: false,
    component: LandingContainer,
    loadData: () => {},
    defaultLoadData,
  },
  {
    path: "/store/free-trial",
    exact: true,
    secure: false,
    component: FreeTrial,
    loadData: () => {},
    defaultLoadData,
  },
  {
    path: "/store/free-trial/checkout",
    exact: true,
    secure: true,
    component: FreeTrialCheckout,
    loadData: () => {},
    defaultLoadData,
  },
  {
    path: "/store/checkout",
    component: CheckoutContainer,
    secure: true,
    loadData: () => {},
    defaultLoadData,
  },
  {
    path: "/store/thank-you",
    component: ThankYouContainer,
    exact: true,
    secure: true,
    loadData: () => {},
    defaultLoadData,
  },
  {
    path: "/store/my-subscription",
    exact: true,
    component: MySubscription,
    secure: true,
    loadData: () => {},
    defaultLoadData,
  },
  {
    path: "/store/:coupon",
    exact: true,
    secure: false,
    component: LandingContainer,
    loadData: () => {},
    defaultLoadData,
  },
  {
    path: "*",
    secure: false,
    component: Error,
    props: {
      title: messages.notFound.title,
      message: messages.notFound.message,
    },
    defaultLoadData,
  },
];
